<template lang="pug">
list-manager.height-100(
  :errors="errors",
  :pages="pages",
  :page="page",
  :loading="loading",
  :next="nextPage",
  :prev="prevPage",
  :count="list.length"
)
  .container.grid-lg
    .columns
      .column.col-6.col-sm-12.my-2(v-for="mensagem in list")
        row(
          :mensagem="mensagem",
          @click="$router.push({ name: 'app.mensagens.recebida', params: { id: mensagem.id } })"
        )
  router-view
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";
import Row from "../Row";

export default {
  components: { Row },
  vuex: {
    "mensagens/recebidas": {
      mutations: ["setQuery"],
      state: ["list", "page", "pages", "count", "query"],
      actions: ["fetchList", "prevPage", "nextPage"],
      getters: ["loading"],
    },
  },
  data() {
    return { q: { arquivada_destinatario_eq: false }, errors: [] };
  },
  methods: {
    async listar() {
      try {
        this.setQuery({ ...this.q });
        await this.fetchList();
      } catch (e) {
        toastErrors(e);
      }
    },
  },
  async created() {
    await this.listar();
    if (this.list.length === 0) {
    }
  },
};
</script>
